import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import useAuthStore from '../store/authStore';
import { Button, Field, Input, PasswordInput } from '../components/ui';
import { toast } from '../components/toast';
import AuthLayout from '../components/AuthLayout';

export default function Login() {
  const login = useAuthStore((s) => s.login);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      toast.error(err.message || 'Falha no login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <form onSubmit={handleSubmit}>
        <h1>Bem-vindo de volta</h1>
        <p className="sub">Entre para gerenciar suas redes.</p>

        <Field label="Email">
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus placeholder="voce@empresa.com" />
        </Field>
        <Field label="Senha">
          <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" />
        </Field>

        <Button type="submit" loading={loading} style={{ width: '100%', marginTop: 4 }}>
          <LogIn size={16} /> Entrar
        </Button>

        <p className="center mt16 muted" style={{ fontSize: 13 }}>
          Acesso criado pelo administrador.
        </p>
      </form>
    </AuthLayout>
  );
}
